import instanceAxios from "./intanceAxios";

export const rrhhService = {
    getRrhh: async (params) => await instanceAxios.get('/authentication/user/', { params }),
    getRrhhByHashCode: async (hashCode) => await instanceAxios.get(`/authentication/user/${hashCode}`),
    postRrhh: async (data) => await instanceAxios.post('/authentication/user/', data),
    putRrhh: async ( data) => await instanceAxios.put(`/authentication/user/`, data),
    postMasiveRrhh: async (data) => await instanceAxios.post('/authentication/user-masive/', data),
    getRrhhByName: async (params) => await instanceAxios.get('/authentication/user-name/', { params }),

}